import { useState } from "react";
import styled from "styled-components";

import Overlay from "../../../Componentes/Overlay";
import Modal from "../../../Componentes/Utils/Modal";
import { formatarData } from "../../../Funcoes/FormatarData";
import { useToast } from "../../../contexts/ToastContext";
import useApi from "../../../hooks/useApi";

const Titulo = styled.h2`
    margin: 0 0 10px 0;
    font-size: 17px;
    color: #263b4b;
    text-align: center;
`;

const Subtitulo = styled.p`
    margin: 0;
    font-size: 14px;
    color: #555;
    text-align: center;
    line-height: 1.5;
`;

const Resumo = styled.div`
    margin: 16px 0 0 0;
    padding: 12px;
    background-color: #f5f7fa;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    font-size: 13px;
    color: #111;

    p {
        margin: 0;
    }

    b {
        color: #263b4b;
    }
`;

const BotoesWrapper = styled.div`
    margin-top: 24px;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
`;

const Botao = styled.button`
    padding: 9px 16px;
    background-color: ${(p) => (p.$cancel ? "#e5e7eb" : "#e11d48")};
    color: ${(p) => (p.$cancel ? "#333" : "white")};
    border: none;
    border-radius: 6px;
    font-weight: 600;
    font-size: 13px;
    cursor: pointer;
    transition: background-color 0.15s ease;

    &:hover:not(:disabled) {
        background-color: ${(p) => (p.$cancel ? "#d1d5db" : "#be123c")};
    }

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
`;

const ModalDeleteDesvio = ({ desvio, fecharModal, onDeleted }) => {
    const api = useApi();
    const { notifyError, notifySuccess } = useToast();
    const [removendo, setRemovendo] = useState(false);

    const handleDelete = async () => {
        if (!desvio?.id) return;

        setRemovendo(true);

        try {
            const { data } = await api.post("/Painel/API/Desvios/Delete/index.php", {
                id: desvio.id,
            });

            if (data?.success) {
                notifySuccess(data?.message || "Desvio removido com sucesso.");
                if (onDeleted) await onDeleted();
                fecharModal();
                return;
            }

            notifyError(data?.message || "Não foi possível remover o desvio.");
        } catch (err) {
            console.error(err);
            const msg = err?.response?.data?.message || "Erro ao remover desvio.";
            notifyError(msg);
        } finally {
            setRemovendo(false);
        }
    };

    return (
        <Overlay state>
            <Modal size="sm">
                <Titulo>Confirmar exclusão</Titulo>
                <Subtitulo>Tem certeza que deseja remover este desvio?</Subtitulo>

                {desvio && (
                    <Resumo>
                        <p>
                            <b>ID:</b> {desvio.id}
                        </p>
                        <p>
                            <b>CENTRO CUSTO:</b> {desvio.centro_custo || "-"}
                        </p>
                        <p>
                            <b>EQUIPE:</b> {desvio.equipe || "-"}
                        </p>
                        <p>
                            <b>DATA:</b>{" "}
                            {desvio.data_ocorrido ? formatarData(desvio.data_ocorrido) : "-"}
                        </p>
                        <p>
                            <b>CLASSIFICAÇÃO:</b> {desvio.classificacao_risco || "-"}
                        </p>
                    </Resumo>
                )}

                <BotoesWrapper>
                    <Botao type="button" $cancel onClick={fecharModal} disabled={removendo}>
                        CANCELAR
                    </Botao>
                    <Botao type="button" onClick={handleDelete} disabled={removendo}>
                        {removendo ? "REMOVENDO…" : "REMOVER"}
                    </Botao>
                </BotoesWrapper>
            </Modal>
        </Overlay>
    );
};

export default ModalDeleteDesvio;
